import { path, difference } from 'ramda';
import { fundraisersInitialState } from './fundraiser.initialState';
import {
	GET_FUNDRAISERS,
	FETCH_USER_FUNDRAISER_SUCCEEDED,
	CLEAR_FUNDRAISERS,
	FETCH_FUNDRAISERS_SUCCEEDED,
	FETCH_FUNDRAISER_SUCCEEDED,
	FETCH_FUNDRAISER_FAILED,
	FETCH_FUNDRAISERS_FAILED,
	UPDATE_FUNDRAISER_SUCCEEDED,
	UPDATE_USER_FUNDRAISER_SUCCEEDED,
} from './fundraiser.action';

export const fundraisersReducer = (state = fundraisersInitialState, action) => {
	switch (action.type) {
		case FETCH_FUNDRAISERS_SUCCEEDED: {
			const fundraisers = {};
			const idsFetched = [];
			for (const fundraiser of action.payload) {
				idsFetched.push(fundraiser._id);
				fundraisers[fundraiser._id] = {
					...(state.entities[fundraiser._id] || {}),
					...fundraiser,
				};
			}

			return {
				...state,
				fetching: difference(state.fetching, idsFetched),
				entities: {
					...state.entities,
					...fundraisers,
				},
			};
		}

		case FETCH_FUNDRAISERS_FAILED: {
			const failedFundraiserIds = [];
			for (const fundraiser of action.payload) {
				failedFundraiserIds.push(fundraiser._id);
			}

			return {
				...state,
				fetching: difference(state.fetching, failedFundraiserIds),
				entities: state.entities,
			};
		}

		case GET_FUNDRAISERS: {
			return {
				...state,
				fetching: [...state.fetching, ...action.payload],
			};
		}

		case FETCH_FUNDRAISER_SUCCEEDED: {
			const fetchedFundraiserId = path(['payload', '_id'], action);
			const fundraisers = {};

			if (fetchedFundraiserId) {
				fundraisers[fetchedFundraiserId] = {
					...(state.entities[fetchedFundraiserId] || {}),
					...action.payload,
				};
			}

			return {
				...state,
				fetching: difference(state.fetching, [fetchedFundraiserId]),
				entities: {
					...state.entities,
					...fundraisers,
				},
			};
		}

		case FETCH_FUNDRAISER_FAILED: {
			const failedFundraiserId = path(['payload', '_id'], action);

			return {
				...state,
				fetching: difference(state.fetching, [failedFundraiserId]),
				entities: state.entities,
			};
		}

		case UPDATE_FUNDRAISER_SUCCEEDED: {
			const { _id } = action.payload;
			return {
				...state,
				entities: {
					...state.entities,
					[_id]: {
						...(state.entities[_id] || {}),
						...action.payload,
					},
				},
			};
		}

		case UPDATE_USER_FUNDRAISER_SUCCEEDED:
		case FETCH_USER_FUNDRAISER_SUCCEEDED: {
			const { _id } = action.payload;
			return {
				...state,
				me: _id,
				entities: {
					...state.entities,
					[_id]: {
						...(state.entities[_id] || {}),
						...action.payload,
					},
				},
			};
		}

		case CLEAR_FUNDRAISERS: {
			return fundraisersInitialState;
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/fundraisers/fundraiser.reducer.js